import { isArray, isNil } from 'lodash';
import { Weekday } from 'rrule';
import { Text } from '@shared/components/Text';
import { ButtonView, View } from '@shared/components/View';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext';
import { Colors } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { DaysOfWeek, buildCustomRRule } from './utils';
import styles from './WeekOptions.module.css';

export function WeekOptions({
  rruleOptions,
  setRruleOptions,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const isDesktop = useIsDesktop();

  const setDayOfWeek = (day: Weekday, isDaySelected: boolean) => {
    setRruleOptions(prev => {
      const prevByweekday =
        !isNil(prev) && !isNil(prev?.byweekday) ? (prev.byweekday as Weekday[]) : [];
      const newByweekday =
        isNil(prev) || isNil(prev?.byweekday)
          ? []
          : [...prevByweekday.filter(d => d.weekday !== day.weekday)];
      if (!isDaySelected) {
        newByweekday.push(day);
      }

      return buildCustomRRule(prev, {
        byweekday: newByweekday,
      });
    });
  };

  return (
    <View gap={1}>
      <Text size="body1" weight="semibold">
        {i18n('workflowTemplate.component.dateAndRepeat.onDotDotDot')}
      </Text>
      <View
        row
        centerVertically
        paddingVertical={isDesktop ? 1 : 2}
        style={{ justifyContent: 'space-between' }}
      >
        {DaysOfWeek.map((weekday: Weekday) => {
          const isDaySelected =
            !isNil(rruleOptions) &&
            isArray(rruleOptions?.byweekday) &&
            rruleOptions?.byweekday?.includes(weekday);
          return (
            <ButtonView
              key={weekday.toString()}
              className={[styles.dayChip, isDaySelected && styles.selected]}
              aria-pressed={isDaySelected}
              onClick={() => setDayOfWeek(weekday, isDaySelected)}
            >
              <Text
                size="body2"
                style={{ fontSize: 14, color: isDaySelected ? Colors.v2.white : Colors.v2.purple }}
              >
                {weekday.toString()}
              </Text>
            </ButtonView>
          );
        })}
      </View>
    </View>
  );
}
